angular.module("coursemap").component("studentEmailConfirmation", {
  templateUrl: "templates/student/setup_email_sent.html"
})
